import React from 'react';

const Hidden = (props:any) => {
    return (
        <input
            className="form-input"
            id={props.name}
            name={props.name}
            type="hidden"
            value={props.value}
            onChange={props.handleChange}
        />
    )
}

export default Hidden;
